// extracted by mini-css-extract-plugin
export const linkArrow = "link-arrow-module--linkArrow--HI64p";
export const textLarge = "link-arrow-module--textLarge--3SS3i";
export const icon = "link-arrow-module--icon--24BZu";